import { render, staticRenderFns } from "./OptionThreeBulletsIcon.vue?vue&type=template&id=70b517b8"
import script from "./OptionThreeBulletsIcon.vue?vue&type=script&lang=js"
export * from "./OptionThreeBulletsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports